import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './WelcomeScreen.css';

const WelcomeScreen = () => {
  const [showWelcome, setShowWelcome] = useState(true);
  const navigate = useNavigate();
  const starCanvasRef = useRef(null);

  useEffect(() => {
    // After 2 seconds, transition to "Taking you to your dashboard"
    const welcomeTimer = setTimeout(() => {
      setShowWelcome(false);
    }, 2000);

    // After another 1.5 seconds (total 3.5s), navigate to dashboard
    const navTimer = setTimeout(() => {
      navigate('/dashboard');
    }, 3500);

    // Cleanup timers
    return () => {
      clearTimeout(welcomeTimer);
      clearTimeout(navTimer);
    };
  }, [navigate]);

  // Canvas animation effect (stars from homepage)
  useEffect(() => {
    const canvas = starCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let stars = [];

    const setupCanvas = () => {
      if (!canvas) return;
      const dpr = window.devicePixelRatio || 1;
      const intendedDrawBufferWidth = window.innerWidth;
      const intendedDrawBufferHeight = window.innerHeight;
      canvas.width = intendedDrawBufferWidth * dpr;
      canvas.height = intendedDrawBufferHeight * dpr;
      canvas.style.width = intendedDrawBufferWidth + 'px';
      canvas.style.height = intendedDrawBufferHeight + 'px';
      stars = [];
      for (let i = 0; i < 100; i++) {
        stars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          radius: Math.random() * 1.5,
          vx: Math.floor(Math.random() * 50) - 25,
          vy: Math.floor(Math.random() * 50) - 25
        });
      }
    };

    const drawStars = () => {
      if (!ctx || !canvas) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'lighter';
      stars.forEach(s => {
        ctx.fillStyle = "#fff";
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.radius, 0, 2 * Math.PI);
        ctx.fill();
        ctx.fillStyle = 'rgba(255, 255, 255, 0.05)';
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.radius + 2, 0, 2 * Math.PI);
        ctx.fill();
      });
      ctx.beginPath();
      for (let i = 0; i < stars.length; i++) {
        ctx.moveTo(stars[i].x, stars[i].y);
        if (i < stars.length - 1) {
          ctx.lineTo(stars[i + 1].x, stars[i + 1].y);
        }
      }
      ctx.lineWidth = 0.05;
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
      ctx.stroke();
    };

    const updateStars = () => {
      stars.forEach(s => {
        s.x += s.vx / 100;
        s.y += s.vy / 100;
        if (s.x < 0 || s.x > canvas.width) s.vx = -s.vx;
        if (s.y < 0 || s.y > canvas.height) s.vy = -s.vy;
      });
    };

    setupCanvas();
    const interval = setInterval(() => {
      updateStars();
      drawStars();
    }, 1000 / 30);

    const handleResize = () => setupCanvas();
    window.addEventListener('resize', handleResize);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="welcome-screen">
      <canvas 
        ref={starCanvasRef} 
        style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          width: '100%', 
          height: '100%', 
          zIndex: 0 
        }}
      />
      <div 
        className="overlay" 
        style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          background: 'radial-gradient(circle at center, rgba(255,255,255,0.03), rgba(0,0,0,0.9))', 
          pointerEvents: 'none', 
          zIndex: 1 
        }}
      />
      <div style={{ position: 'relative', zIndex: 2 }}>
        {showWelcome ? (
          <h1 className="welcome-title fade-in">
            Welcome
          </h1>
        ) : (
          <h2 className="welcome-subtitle fade-in">
            Taking you to your dashboard.
          </h2>
        )}
      </div>
    </div>
  );
};

export default WelcomeScreen;

